import Vue from 'vue'
import Confirm from './Confirm'

const components = {
    Confirm
}

let instance = {},
    Ruler = {}

const body = document.body || document.documentElement,
    root = document.createElement('div')

body.appendChild(root)

const initComponents = function (type = '', options = []) {
    if (components[type]) {
        if (!instance[type]) {
            const div = document.createElement('div')
            root.appendChild(div)
            const MessageBox = Vue.extend(components[type])

            instance[type] = new MessageBox({ el: div })
        }
        const ins = instance[type]

        for (let i in options) ins[i] = options[i]

        Vue.nextTick(() => ins.visible = true)

        return new Promise((resolve, reject) => {
            ins._promise = {
                resolve,
                reject
            }
        }).finally(() => {
        })
    } else {
        return Promise.reject('组件不存在')
    }
}

function popupHandle (i, options) {
    if (typeof options === 'string') {
        options = {
            msg: options
        }
    }
    return initComponents(i, options)
}

for (let i in components) {
    Ruler[i] = popupHandle.bind(components[i], i)
}

export default {
    install (Vue) {
        for (let key in Ruler) {
            console.log(key)
            Vue.prototype[`$${key.toLowerCase()}`] = Ruler[key]
        }
    }
}
